








































































































import uuid from 'uuid/v4';
import Draggable from 'vuedraggable';
import { GridColumn, GridTable } from '@/components/grid';
import FieldBase from '@/components/field/Base.vue';
import InfoBox from '@/components/InfoBox.vue';
import ShowGuide from '@/components/ShowGuide.vue';
import { find as getComponents } from '@/services/component';
import { IProductResource } from '@/services/product';

interface IGenericKeyValue {
  [key: string]: string;
}

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isMobile: this.$store.state.isMobile,
      rowShape: () => ({
        // `index` set by localValue setter
        // `resource_id` set by dropdown
        id: uuid(),
        name: '',
        qty: 1,
      }),
    };
  },
  computed: {
    localValue: {
      get(): Array<IProductResource<any>> {
        return this.value;
      },
      set(value: Array<IProductResource<any>>) {
        // set component index
        this.$emit('input', (
          value.map((component, index) => ({
            ...component,
            index,
          }))
        ));
      },
    },
    resourceList() {
      return this.list.reduce((
        list: IGenericKeyValue,
        resource: IProductResource<any>,
      ) => {
        list[resource.id] = resource.name;
        return list;
      }, {});
    },
  },
  methods: {
    selected(resourceId: string, row: { index: number, data: IProductResource<any> }) {
      this.$set(this.localValue, [row.index], {
        ...this.localValue[row.index],
        resource_id: resourceId,
        detail: (this.list as any).find((resource: IProductResource<any>) => {
          return resource.id === row.data.resource_id;
        }),
      });
      this.$emit('select', row);
    },
  },
  components: {
    Draggable,
    FieldBase,
    GridColumn,
    GridTable,
    InfoBox,
    ShowGuide,
  },
} as IView;
